import { Component, Input } from '@angular/core';

// Maquette d'estimation « action d'équipe » : repère de ce que l'option change dans l'écran.
@Component({
  selector: 'team-action-mock-new',
  template: `<span
    *ngIf="show"
    class="inline-block rounded-full px-2 py-0.5 caption leading-none bg-primary text-primary-contrast whitespace-nowrap"
    >Nouveau</span
  >`,
})
export class TeamActionMockNewBadgeComponent {
  @Input() show = true;
}
